import { galleryItems } from '@/mocks/home';
import SectionHeading from './SectionHeading';

export default function GallerySection() {
  return (
    <section id="gallery" className="hll-scroll-anchor w-full bg-background-50 py-14 md:py-20">
      <div className="mx-auto w-full max-w-[1280px] px-4 md:px-6">
        <SectionHeading
          eyebrow="HD GALLERY"
          title="高清图集 · 图文并重的现场记录"
          desc="一组图讲清一件事：黑料吃瓜网高清图集按场景成套放出，保留原始构图与细节，翻阅时不丢信息。"
          actionLabel="更多图集"
          actionHref="#index"
        />

        <div className="mt-8 grid grid-cols-2 gap-4 md:grid-cols-3">
          {galleryItems.map((item) => (
            <a
              key={item.id}
              href="#feed"
              className="group relative block h-[180px] cursor-pointer overflow-hidden rounded-lg border border-background-300/60 md:h-[260px]"
            >
              <img
                src={item.image}
                alt={`${item.title} - 黑料吃瓜网高清图集`}
                title={`${item.title} 黑料吃瓜网图片`}
                className="absolute inset-0 h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/85 via-foreground-950/20 to-transparent"></div>
              <div className="absolute inset-x-0 bottom-0 flex items-end justify-between gap-2 p-4">
                <div className="min-w-0">
                  <h3 className="truncate font-heading text-sm font-semibold text-background-50 md:text-base">
                    {item.title}
                  </h3>
                  <span className="mt-1 flex items-center gap-1.5 text-[11px] text-background-300">
                    <span className="flex h-3.5 w-3.5 items-center justify-center">
                      <i className="ri-image-2-line text-xs"></i>
                    </span>
                    {item.count}
                  </span>
                </div>
                <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-background-50/90 text-foreground-900 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                  <i className="ri-arrow-right-up-line text-base"></i>
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}